import FullCalendar from "@fullcalendar/react";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

import { CalendarWrapper } from "../../mgmtview/calendar/calendarwrapper.js";

const ResourceTimelineCalendar = ({
  calendarRef,
  onCalendarMount,
  duration,
  locale,
  editable = false,
  selectable = false,
  dateClick,
  eventClick,
  eventDrop,
  eventResize,
  select,
  eventContent,
  slotLaneContent,
  slotLaneClassNames,
  resources,
  resourceAreaHeaderContent,
  resourceLabelContent,
  events,
  datesSet,
  slotLabelContent,
  eventDataTransform,
  resourceOrder = "title,nr",
  nowIndicatorClassNames = () => "now",
}) => {
  return (
    <CalendarWrapper className="personal-calendar ag-theme-material styles-ag flex-grow-1 w-100">
      <FullCalendar
        ref={(instance) => {
          calendarRef.current = instance;
          if (instance && onCalendarMount) onCalendarMount(instance);
        }}
        height="contentHeight"
        schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
        plugins={[resourceTimelinePlugin, dayGridPlugin, interactionPlugin]}
        initialView="resourceTimelineMonth"
        views={{
          resourceTimelineMonth: {
            type: "resourceTimelineMonth",
            duration,
            slotDuration: { days: 1 },
            slotMinWidth: 120,
          },
        }}
        weekNumbers
        locale={locale}
        firstDay={1}
        weekends
        editable={editable}
        selectable={selectable}
        dateClick={dateClick}
        eventClick={eventClick}
        eventDrop={eventDrop}
        eventResize={eventResize}
        select={select}
        eventContent={eventContent}
        headerToolbar={{ left: "", center: "", right: "" }}
        resourceOrder={resourceOrder}
        slotLaneContent={slotLaneContent}
        slotLaneClassNames={slotLaneClassNames}
        resources={resources}
        resourceAreaWidth="12%"
        resourceAreaHeaderContent={resourceAreaHeaderContent}
        resourceLabelContent={resourceLabelContent}
        events={events}
        datesSet={datesSet}
        nowIndicatorClassNames={nowIndicatorClassNames}
        slotLabelContent={slotLabelContent}
        eventDataTransform={eventDataTransform}
      />
    </CalendarWrapper>
  );
}

export default ResourceTimelineCalendar;
